// Google Places utility functions for ServiceAM
window.GooglePlacesUtils = {
  // Extract zipcode from various place components
  extractZipcode(addressComponents) {
    for (const component of addressComponents) {
      if (component.types.includes('postal_code')) {
        return component.long_name;
      }
      if (component.types.includes('postal_code_prefix')) {
        return component.long_name;
      }
    }
    return null;
  },

  // Extract city from address components
  extractCity(addressComponents) {
    for (const component of addressComponents) {
      if (component.types.includes('locality')) {
        return component.long_name;
      }
      if (component.types.includes('administrative_area_level_2')) {
        return component.long_name;
      }
      if (component.types.includes('sublocality_level_1')) {
        return component.long_name;
      }
    }
    return null;
  },

  // Validate US zipcode format
  isValidUsZipcode(zipcode) {
    const zipPattern = /^\d{5}(-\d{4})?$/;
    return zipPattern.test(zipcode);
  },

  // Format zipcode to standard format
  formatZipcode(zipcode) {
    if (!zipcode) return '';

    // Remove all non-digits
    const digits = zipcode.replace(/\D/g, '');

    // Format as XXXXX or XXXXX-XXXX
    if (digits.length === 5) {
      return digits;
    } else if (digits.length === 9) {
      return `${digits.slice(0, 5)}-${digits.slice(5)}`;
    }

    return zipcode; // Return original if it doesn't match expected length
  },

  // Get place type priority for autocomplete
  getPlaceTypePriority(types) {
    const priorityMap = {
      street_address: 1,
      premise: 2,
      subpremise: 3,
      route: 4,
      neighborhood: 5,
      locality: 6,
      sublocality: 7,
      postal_code: 8,
      administrative_area_level_2: 9,
      administrative_area_level_1: 10,
    };

    let highestPriority = 999;
    for (const type of types) {
      if (priorityMap[type] && priorityMap[type] < highestPriority) {
        highestPriority = priorityMap[type];
      }
    }
    return highestPriority;
  },
};

// Initialize Google Places when the page loads
document.addEventListener('DOMContentLoaded', function () {
  // Listen for the Google Places API ready event
  window.addEventListener('google-places-ready', function () {});

  // Also check if the API is already loaded
  if (typeof google !== 'undefined' && google.maps && google.maps.places) {
    window.dispatchEvent(new CustomEvent('google-places-ready'));
  }
});
